module.exports = __webpack_public_path__ + "img/full5-min.97912712.png";